import React from 'react'
import CustomersTable from '../src/components/sections/Customers/Table'
import CustomerResume from '../src/components/sections/Customers/CustomerResumeCard'
import CustomerDetailForm from '../src/components/sections/Customers/CustomerDetailForm'
import QueryCustomers from '../src/components/graphql/getCustomers'
import MutationCustomers from '../src/components/graphql/updateCustomers'
import { Pagination, Drawer, Container, Main, FlexContainer, HasPermissions, NotFound } from '../src/components/common'
class Customers extends React.Component {
    state = {
        collapsed: true,
        loading: true,
        drawerOpened: false,
        childDrawerOpened: false,
        currentSeleted: null,
        currentSeletedIndex: 0,
        data: [],
        currentPage: 1,
        pageSize: 50
    }

    onChangePageSize = ({ value = { value: 50 } }) => this.setState({ pageSize: value.value, currentPage: 1, loading: !this.state.loading })
    onChange = currentPage => this.setState({ currentPage, loading: !this.state.loading })

    toggleDrawer = (currentSeleted, currentSeletedIndex) => {
        // this.setState({
        //   drawerOpened: !this.state.drawerOpened,
        //   currentSeleted,
        //   currentSeletedIndex
        // })
    }

    closeDrawer = () => {
        const wasOpened = this.state.drawerOpened
        const { currentSeleted, currentSeletedIndex } = this.state
        this.setState({
            drawerOpened: !wasOpened,
            currentSeleted: wasOpened ? null : currentSeleted,
            currentSeletedIndex: wasOpened ? null : currentSeletedIndex
        })
    }

    toggleChildDrawer = () => {
        const wasOpened = this.state.childDrawerOpened
        this.setState({
            childDrawerOpened: !wasOpened
        })
    }

    render () {
        const { drawerOpened, childDrawerOpened, currentSeleted, currentPage, pageSize } = this.state
        return (
            <HasPermissions
                to={['customers-page:view']}
                otherwise={<NotFound firstTextLine='Página no encontrada' style={{ minHeight: '90vh' }} />}
            >
                <Container style={{ height: '100%', background: '#ffffff', overflowY: 'auto' }}>
                    <Main withFooter>
                        <FlexContainer shrink={0} grow={1} style={{ padding: '20px' }} direction='column'>
                            <QueryCustomers fetchPolicy='network-only' variables={{ sort: [{ field: 'updatedIn', dir: 'desc' }], page: currentPage, size: pageSize }}>
                                {({ loading, data, count, fetchMore }) => (
                                    <div style={{ width: '100%' }}>
                                        <CustomersTable
                                            style={{ backgroundColor: 'white' }}
                                            fetchMore={fetchMore}
                                            total={count}
                                            onRowClick={this.toggleDrawer}
                                            loading={loading}
                                            data={data}
                                        />
                                        <Pagination
                                            total={count}
                                            pageSize={pageSize}
                                            onChange={this.onChange}
                                            onChangePageSize={this.onChangePageSize}
                                            defaultPageSize={50}
                                            optionsUp
                                            current={currentPage}
                                        />
                                    </div>
                                )}
                            </QueryCustomers>
                            <Drawer closable title='Resumen Cliente' visible={drawerOpened} onClose={() => this.closeDrawer()}>
                                <CustomerResume data={currentSeleted} toggleChildDrawer={this.toggleChildDrawer} />
                                <Drawer title='Editar Datos Cliente' visible={childDrawerOpened} onClose={this.toggleChildDrawer}>
                                    <MutationCustomers>
                                        {({ updateFn, loading, ...props }) => (
                                            <CustomerDetailForm
                                                loading={loading}
                                                initialValues={currentSeleted}
                                                onReset={this.toggleChildDrawer}
                                                onSubmit={({ id, ...input }) => updateFn({ variables: { id, payload: { ...input } } })}
                                            />
                                        )}
                                    </MutationCustomers>
                                </Drawer>
                            </Drawer>
                        </FlexContainer>
                    </Main>
                </Container>
            </HasPermissions>
        );
    }
}

export default Customers;
